import React from "react";
import { validate } from "../../../utilities/formValidators";
import styled from "styled-components";
import classNames from "classnames";

export interface IDropdownProps {
    dataTestId?: string;
    required?: boolean;
    className?: string;
    containerClassName?: string;
    onChange: (e, boolean?) => void;
    options: any;
    id: string;
    placeholder: string;
    defaultValue?: string;
    value?: any;
    disabled?: boolean
    selectClassName?: string;
    require?: boolean;
}

export default styled((props: IDropdownProps) => {

    function handleSelect(e) {
        if (validate(e, "select")) {
            props.onChange(e);
        } else {
            props.onChange(e, false);
        }
    }

    return (
        <div className={classNames("w-100", props.containerClassName)} >
            <div className={classNames("form-group", props.className)}>
                <select id={props.id} data-test-id={props.dataTestId} name={props.id} className={classNames("form-control rounded", props.selectClassName)} onChange={handleSelect} value={props.defaultValue || props.placeholder} disabled={props.disabled}>
                    <option value={props.placeholder} disabled hidden className="hidden">{props.placeholder}</option>
                    {(props.options || []).map(option => (
                        <option value={option.id} key={`${option.id}${option.name}`} disabled={option.disabled ?? false}>{option.name}</option>
                    ))}
                </select>
            </div>
        </div>
    );
})`
    option.hidden{
        display: none;
    }

    option[disabled] {
        color: #e9e9e9;
    }

    select {
        height: 54.39px;
    }
`;